import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";

export default function Habit_6_Promotion({
  version = "promotion",
}: {
  version?: string; // v5...
}) {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(`/${version}-onboarding/habit/7`);
  };

  const pageKey = "habit_6";

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {});

  return (
    <Box sx={{ paddingBottom: "40px" }}>
      <Stack
        spacing={10}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"내게 맞는 플랜을 선택할 수 있습니다."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {"디스턴싱 100일 완성 프로그램은 세 가지 플랜으로 제공됩니다."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "매일 프리미엄 코칭을 받으며 빠르고 밀도 있는 변화를 원한다면 마스터 플랜(465,000원)을 선택하세요."
            }
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "주 3회 이상 참여하며 더욱 확실한 변화를 만들어가고 싶다면 챌린저 플랜(395,000원)이 가장 적합합니다."
            }
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "일주일에 단 2일만 시간을 낼 수 있다면 스타터 플랜(295,000원)을 추천합니다."
            }
          </CustomTypography>
        </Stack>
      </Stack>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
